import AxiosClient from "../../../services/axios.services";

class PlanCarreraIndividualServices {
    getCursosComparacion = (params) => {
        return AxiosClient.get("/api/app/carrera_sucesion_cursos_comparacion/", {
            headers: { "Content-Type": "application/json" },
            params: params,
        });

    }   

    
    getEncabezadoPlanCarrera = (params) => {
        return AxiosClient.get("/api/app/carrera_sucesion_listado_pantalla_colaborador/", {
            headers: { "Content-Type": "application/json" },
            params: params,
        });
    }
    
    createCursosComparacion = (data) =>
        AxiosClient.post(
            "/api/app/carrera_sucesion_cursos_comparacion/",
            data,
            {
                headers: { "Content-Type": "application/json" },
            }
        );

    addCursosColaborador = (data) =>
        AxiosClient.post(
            "/api/app/carrera_sucesion_matriz_cursos_colaborador/",
            data,
            {
                headers: { "Content-Type": "application/json" },
            }
        );

    editCursosComparacion = (id, data) =>

        AxiosClient.put(`/api/app/update_cursos_aceptacion/${id}/`, data, {
            headers: { "Content-Type": "application/json" },
        });

    deleteCursoColaborador = (id) =>
        AxiosClient.delete(
            `/api/app/carrera_sucesion_matriz_cursos_colaborador/${id}/`,
            {
                headers: { "Content-Type": "application/json" },
            }
        );
}

export default new PlanCarreraIndividualServices();